import { createContext } from "react";

const footer = {
     footerpage:'',
    setfooterpage :()=>{},
}

export const Footerpages = createContext(footer)